import {locationLabel} from '@/utils/functions'

/**
 * "Arriving in 10 min · We'll be at Toronto Pearson International Airport"
 *
 * ── ⚠️ IT IS ALWAYS A COUNTDOWN, NEVER A CLOCK TIME ───────────────────────────────
 * This header used to fall back to "Scheduled for 12:14 PM" whenever there was no live
 * ETA, which answers a different question from the one that brought someone to this
 * screen. A passenger watching a map is asking "how long until my car gets here"; a booked
 * time makes them do the subtraction themselves, against a clock they may not have looked
 * at, in a timezone they may have just flown into. The mobile app counts down and so does
 * this.
 *
 * ── ⚠️ ONE SOURCE: THE LIVE SOLVE, OR "--" ───────────────────────────────────────
 * The number is the same Directions solve the map draws its line from — "when will this
 * car reach me" — and it needs the driver's position. Until that exists the header reads
 * "Arriving in --". It used to count down to the BOOKED pickup instead, which showed a
 * figure like "1h 12m" that looked measured and was not.
 */

export default function EtaHeader({trip, route, nextStop, hasPosition}) {
    /* The live solve, when there is a driver position to solve from.

       ⚠️ NO BOOKED-TIME FALLBACK ANY MORE — "--" until the live ETA exists. Counting down to
       the booked pickup ("Arriving in 1h 12m") read as a measurement of where the car is,
       which it never was; a dash says honestly that there is nothing measured yet. */
    const figure = (hasPosition ? route?.totalDurationText : null) || '--'

    const where = locationLabel(nextStop?.label || nextStop?.point) || locationLabel(trip?.origin)

    return (
        <header className="text-center">
            <p className="mb-1! text-(--text-secondary)">
                Arriving in <span className="text-4xl font-bold text-(--text-primary) max-md:text-2xl">{figure}</span>
            </p>

            {where && <p className="mb-0! text-(--text-secondary)">We&apos;ll be at {where}</p>}
        </header>
    )
}

export {EtaHeader}
